export default __webpack_public_path__ + "87ad8cb59b0433d8df40dc58e60be82d.svg";